import { IModelType } from "mobx-state-tree";

/**
 *
 */
export function assignStaticMST<
  T extends IModelType<any, any>,
  TStatics extends object
>(m: T, statics: TStatics): T & TStatics {
  Object.keys(statics).forEach((k) => ((m as any)[k] = (statics as any)[k]));
  return m as T & TStatics;
}
